
import BreadcrumbsNavigation from '@/components/BreadcrumbsNavigation'
import ProductListingBanner from '@/components/ProductListingBanner'

export default {
  components: {
    BreadcrumbsNavigation,
    ProductListingBanner,
  },
  props: {
    breadcrumbsLinks: {
      type: Array,
      default: () => [],
    },
    categoryId: {
      type: Number,
      default: undefined,
    },
    brandId: {
      type: Number,
      default: undefined,
    },
  },
}
